import { useOutletContext } from "react-router";
import { JSX } from "react";

import RFPs from "../../RFPs";
import { RfpsContext } from "../types";

const SubmittedRfps = (): JSX.Element => {
  const { brokerId } = useOutletContext<RfpsContext>();

  return <RFPs isBrokerPartner brokerId={brokerId} />;
};

export { SubmittedRfps };
